/**
 * O que faz: unifica título, contexto e ações das seções de configurações.
 * Onde usa: abas de Configurações e consumidores compartilhados dessas seções.
 * Conexões: Lucide e ações recebidas por composição React.
 * Tabelas: nenhuma.
 * Data: 30/08/2026 (raio, caixa de ícone e textos do Gens Design System em 07/10/2026).
 */
import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';

export interface CabecalhoConfiguracoesProps {
  titulo: string;
  descricao: ReactNode;
  icone: LucideIcon;
  complementoTitulo?: ReactNode;
  acoes?: ReactNode;
  aviso?: ReactNode;
}

export function CabecalhoConfiguracoes({
  titulo,
  descricao,
  icone: Icone,
  complementoTitulo,
  acoes,
  aviso,
}: CabecalhoConfiguracoesProps) {
  // Ações permanecem no consumidor para preservar permissões, foco e handlers.
  return (
    <header className="min-w-0 rounded-3xl border border-border bg-card p-4 shadow-[var(--lg-sombra-1)] sm:p-5">
      <div className="flex min-w-0 flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex min-w-0 flex-1 items-start gap-3">
          {/* Caixa de ícone da seção 8: 44 px, raio 12, musgo com ícone verde profundo. */}
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-secondary text-accent-foreground">
            <Icone aria-hidden="true" className="h-5 w-5" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <h2 className="min-w-0 break-words font-display text-lg font-semibold leading-snug tracking-tight text-foreground sm:text-xl">
                {titulo}
              </h2>
              {complementoTitulo}
            </div>
            <div className="mt-1 max-w-[65ch] break-words text-sm leading-relaxed text-muted-foreground">
              {descricao}
            </div>
          </div>
        </div>
        {acoes && <div className="flex min-w-0 flex-wrap items-center gap-2 sm:max-w-[45%] sm:justify-end">{acoes}</div>}
      </div>
      {aviso && <div className="mt-3">{aviso}</div>}
    </header>
  );
}
